import parcelPicker from "emun.invoice/parcel-picker/parcel-picker";

export default () => ({
  scope: false,
  link(scope, element, attr) {
    const options = Object.assign(
      {},
      scope.$eval(attr.parcelPicker || attr.ngModel),
      attr
    );
    const open = () => parcelPicker(options);
    const $targets = attr.parcelPickerSelector
      ? element.find(attr.parcelPickerSelector)
      : element;
    $targets.on("click", open);
  }
});
